import { Action } from '@ngrx/store';
import { DataExport } from '../../utils/export/data-export';

export enum AllotmentsExportActionTypes {
  CanAccessAllotmentsTab = '[Allotments Export] Can Access Allotments Tab',
  ExportModalOpened = '[Allotments Export] Export Modal Opened',
  ExportModalClosed = '[Allotments Export] Export Modal Closed',
  ExportGridsDataPrepared = '[Allotments Export] Export Grids Data Prepared'
}

export class CanAccessAllotmentsTab implements Action {
  public readonly type = AllotmentsExportActionTypes.CanAccessAllotmentsTab;

  constructor(public canAccess: boolean) {}
}

export class ExportModalOpened implements Action {
  public readonly type = AllotmentsExportActionTypes.ExportModalOpened;
}

export class ExportModalClosed implements Action {
  public readonly type = AllotmentsExportActionTypes.ExportModalClosed;
}

export class ExportGridsDataPrepared implements Action {
  public readonly type = AllotmentsExportActionTypes.ExportGridsDataPrepared;
  constructor(
    public exportGridsData: {
      sheetName: string;
      data: DataExport.ExportCell[][];
    }[]
  ) {}
}

export type AllotmentsExportActionUnion =
  | CanAccessAllotmentsTab
  | ExportModalOpened
  | ExportModalClosed
  | ExportGridsDataPrepared;
